import { useLang } from "@/context/LanguageContext";
import { STUDIO } from "@/data/content";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="main-footer"
      className="border-t border-white/5 bg-[#050507] py-16"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <div className="font-heading text-xl font-semibold text-white">
            Inovo<span className="text-[#00F0FF]">Design</span>
          </div>
          <p className="mt-2 text-sm text-zinc-500">{t.footer.tagline}</p>
          <p data-testid="footer-confidentiality-note" className="mt-4 max-w-md text-xs leading-relaxed text-zinc-600">
            {t.footer.confidentiality}
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-2">
          <a
            href={`mailto:${STUDIO.email}`}
            data-testid="footer-contact-email-link"
            className="font-mono text-sm text-zinc-300 hover:text-[#00F0FF] transition-colors duration-300"
          >
            {STUDIO.email}
          </a>
          <p className="text-xs text-zinc-600">
            © {year} {STUDIO.name} {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
